export default __webpack_public_path__ + "static/media/image02.75c3a178.jpg";